export const fieldTransition = `0.3s background-color ease-in-out, 0.3s box-shadow ease-in-out`;
export const fieldInputTransition = `0.3s background-color ease-in-out, 0.3s box-shadow ease-in-out,
0.1s padding ease-in-out`;
